import React from 'react';

export type HandMode = 'left' | 'right' | 'both';

interface HandToggleProps {
  value: HandMode;
  onChange: (mode: HandMode) => void;
  className?: string;
  disabled?: boolean;
}

export const HandToggle: React.FC<HandToggleProps> = ({
  value,
  onChange,
  className = '',
  disabled = false
}) => {
  const handleClick = () => {
    if (disabled) return;
    const modes: HandMode[] = ['left', 'right', 'both'];
    const currentIndex = modes.indexOf(value);
    const nextIndex = (currentIndex + 1) % modes.length;
    onChange(modes[nextIndex]);
  };

  const getIcon = () => {
    switch (value) {
      case 'left':
        return (
          <svg width="20" height="20" viewBox="0 0 100 100" fill="currentColor">
            <path d="m85.85116,64.23146c-1.9,-1.7 -4.5,-2.5 -7.1,-2.2l-16.5,2.3l0,-49.3c0,-4.6 -3.5,-8.5 -7.9,-8.7c-4.7,-0.2 -8.5,3.7 -8.5,8.5l0,17.2c-1.1,-0.6 -2.3,-0.9 -3.6,-0.9c-3.5,0 -6.4,2.2 -7.6,5.4c-1.1,-0.6 -2.4,-1 -3.8,-1c-3.5,0 -6.5,2.4 -7.4,5.7c-1.2,-0.7 -2.6,-1.1 -4.1,-1.1l0,0c-1.5,0 -3,0.4 -4.3,1.2c-2.6,1.7 -4,4.4 -4,7.4l0,4.8c0,12.8 2.2,23.3 6.6,35.3l1.2,3.3c0.3,0.9 1.4,1.4 3.3,1.5c1.9,0.1 36,0 36,0c0.4,0 1.1,-0.2 1.5,-0.5l10.1,-6.8l13.9,-6.7c2.4,-1.2 4.3,-3.4 5,-6.1c0.9,-3.5 -0.3,-7.1 -2.8,-9.3zm-4,10.9l-14.2,6.8c-0.1,0 -0.2,0.1 -0.3,0.2l-9.7,6.6l-35.2,0c-4.5,-12 -6.9,-23 -6.9,-35.9l0,-4.2c0,-1 0.3,-2 0.9,-2.7c0.7,-0.8 1.7,-1.3 2.8,-1.3c0,0 0,0 0,0c2.1,0 3.8,1.8 3.8,3.9l0,5.1c0,1.2 0.9,2.3 2.1,2.5c1.4,0.1 2.5,-1 2.5,-2.4c0,-0.1 0,-0.1 0,-0.2l0,-10.1c0,-1.9 1.7,-3.5 3.6,-3.2c1.6,0.2 2.8,1.7 2.8,3.4l0,2.3c0,0 0,0 0,0l0,4.8c0,1.3 1,2.4 2.3,2.4c1.3,0 2.3,-1.1 2.3,-2.4l0,-7.2l0,-3.8c0,-2 1.5,-3.7 3.4,-3.9c2.1,-0.1 3.9,1.6 3.9,3.7l0,7.6c0,1.2 0.9,2.3 2.1,2.5c1.4,0.1 2.5,-1 2.5,-2.4l0,-7.7l0,-24.6c0,-2 1.5,-3.7 3.4,-3.9c2.1,-0.1 3.9,1.6 3.9,3.7l0,52.2c0,1.7 1.2,2.5 2.6,2.3c4.8,-0.6 19.1,-2.6 19.1,-2.6c1.2,-0.2 2.5,0.2 3.4,1.1c0.9,0.8 1.5,2.1 1.5,3.4c-0.1,1.7 -1.1,3.3 -2.6,4z"/>
          </svg>
        );
      case 'right':
        return (
          <svg width="20" height="20" viewBox="0 0 100 100" fill="currentColor">
            <path d="m14.1,64.1c1.9,-1.7 4.5,-2.5 7.1,-2.2l16.5,2.3l0,-49.3c0,-4.6 3.5,-8.5 7.9,-8.7c4.7,-0.2 8.5,3.7 8.5,8.5l0,17.2c1.1,-0.6 2.3,-0.9 3.6,-0.9c3.5,0 6.4,2.2 7.6,5.4c1.1,-0.6 2.4,-1 3.8,-1c3.5,0 6.5,2.4 7.4,5.7c1.2,-0.7 2.6,-1.1 4.1,-1.1l0,0c1.5,0 3,0.4 4.3,1.2c2.6,1.7 4,4.4 4,7.4l0,4.8c0,12.8 -2.2,23.3 -6.6,35.3l-1.2,3.3c-0.3,0.9 -1.4,1.4 -3.3,1.5c-1.9,0.1 -36,0 -36,0c-0.4,0 -1.1,-0.2 -1.5,-0.5l-10.1,-6.8l-13.9,-6.7c-2.4,-1.2 -4.3,-3.4 -5,-6.1c-0.9,-3.5 0.3,-7.1 2.8,-9.3zm4,10.9l14.2,6.8c0.1,0 0.2,0.1 0.3,0.2l9.7,6.6l35.3,0.1c4.5,-12 6.9,-23 6.9,-35.9l0,-4.2c0,-1 -0.3,-2 -0.9,-2.7c-0.7,-0.8 -1.7,-1.3 -2.8,-1.3c0,0 0,0 0,0c-2.1,0 -3.8,1.8 -3.8,3.9l0,5.1c0,1.2 -0.9,2.3 -2.1,2.5c-1.4,0.1 -2.5,-1 -2.5,-2.4c0,-0.1 0,-0.1 0,-0.2l0,-10.1c0,-1.9 -1.7,-3.5 -3.6,-3.2c-1.6,0.2 -2.8,1.7 -2.8,3.4l0,2.3c0,0 0,0 0,0l0,4.8c0,1.3 -1,2.4 -2.3,2.4c-1.3,0 -2.3,-1.1 -2.3,-2.4l0,-7.2l0,-3.8c0,-2 -1.5,-3.7 -3.4,-3.9c-2.1,-0.1 -3.9,1.6 -3.9,3.7l0,7.5c0,1.2 -0.9,2.3 -2.1,2.5c-1.4,0.1 -2.5,-1 -2.5,-2.4l0,-7.7l0,-24.6c0,-2 -1.5,-3.7 -3.4,-3.9c-2.1,-0.1 -3.9,1.6 -3.9,3.7l0,52.2c0,1.7 -1.2,2.5 -2.6,2.3c-4.8,-0.6 -19.1,-2.6 -19.1,-2.6c-1.2,-0.2 -2.5,0.2 -3.4,1.1c-0.9,0.8 -1.5,2.1 -1.5,3.4c0,1.7 1,3.3 2.5,4z"/>
          </svg>
        );
      case 'both':
        return (
          <svg width="20" height="20" viewBox="0 0 100 100" fill="currentColor">
            <path d="m92.94372,27.90174c-1,-1 -2.3,-1.6 -3.6,-1.7c0,0 -0.1,0 -0.1,0c-0.7,0 -1.4,0.1 -2.1,0.3l0.3,-3.8c0.2,-2.1 -0.6,-3.5 -1.3,-4.3c-1,-1.1 -2.4,-1.7 -3.8,-1.7c0,0 0,0 0,0c-0.8,0 -1.6,0.1 -2.3,0.4l0.1,-1.8c0.2,-3 -2.2,-5.6 -5.2,-5.8c-1.5,-0.1 -2.9,0.4 -4,1.4c-1.1,1 -1.8,2.4 -1.8,3.8l-0.9,17.1c-0.3,-0.2 -0.7,-0.4 -1.1,-0.6c-1.2,-0.6 -2.4,-1 -3.8,-1.3c0,0 -0.1,0 -0.1,0c-2.3,-0.3 -4.5,-0.6 -8.3,1.1c-2.4,1.1 -4.3,2.4 -5.9,4.2c-2.3,2.6 -1.5,6 -0.5,7.6c0.2,0.3 0.4,0.6 0.7,0.9c-1.4,0 -2.7,0.6 -3.8,1.7c-1.8,1.8 -2,5.4 -0.4,7.5c0.8,1.1 3.1,3.5 7,7.5c5.3,5.5 12.8,8.5 21.2,8.5c16,0 18.6,-8.4 19.7,-16.3l0.6,-4.1c0,-0.1 0,-0.2 0,-0.3c0,-0.9 0.8,-15.6 0.8,-16.4c0.1,-1.4 -0.4,-2.8 -1.4,-3.9zm-1.7,3.8c0,0.1 -0.8,14.6 -0.8,16.5l-0.6,4c-1.1,7.5 -3.1,13.7 -16.7,13.7c-7.6,0 -14.3,-2.7 -19,-7.5c-4.6,-4.8 -6.2,-6.6 -6.7,-7.2c-0.7,-0.8 -0.6,-2.8 0.1,-3.5c0.6,-0.6 1.2,-0.9 1.9,-0.9c0.7,0 1.5,0.4 2,0.9c1.1,1.1 4.4,4.4 4.6,4.5c1.8,1.7 4.4,2.5 6.6,1.9c2.3,-0.5 4,-1.9 4.7,-3.9c1,-2.7 0.2,-6.1 -1.1,-7.7c-1.5,-1.8 -3.4,-2.8 -5.9,-2.9c-2.2,-0.1 -3.3,0.7 -4.5,1.7c-0.2,0.1 -0.4,0.3 -0.6,0.4c-0.5,0.3 -1.5,0.6 -2.6,0.4c-0.7,-0.1 -1.3,-0.4 -1.6,-0.8c-0.4,-0.7 -1,-2.6 0.2,-4c1.3,-1.4 2.8,-2.5 4.8,-3.4c3,-1.3 4.6,-1.1 6.6,-0.9c1,0.2 2,0.5 2.9,1c1.2,0.6 2.1,1.3 2.7,2c0.4,0.5 1.1,0.7 1.7,0.5c0.6,-0.2 1,-0.7 1,-1.4l1.1,-20.2c0,-0.7 0.3,-1.3 0.8,-1.7c0.5,-0.4 1.1,-0.7 1.8,-0.6c1.4,0.1 2.4,1.3 2.3,2.6l-1.2,21.1c0,0.8 0.6,1.6 1.4,1.6c0.8,0 1.6,-0.6 1.6,-1.4l0.8,-14.8c0,-1.5 1.9,-1.8 2.5,-1.8c0.4,0 1.1,0.2 1.5,0.7c0.4,0.5 0.6,1.1 0.6,1.9c0,0 0,0 0,0l-1.3,17.1c-0.1,0.8 0.6,1.6 1.4,1.6c0,0 0.1,0 0.1,0c0.8,0 1.5,-0.6 1.5,-1.4l0.7,-8.8c0.1,-1.6 1.9,-1.7 2.4,-1.7c0,0 0.1,0 0.1,0c0.5,0 1,0.3 1.4,0.7c0.6,0.3 0.9,0.8 0.8,1.7zm-33.1,18.4c0,0 -3.4,-3.3 -4.5,-4.4c-0.1,-0.1 -0.3,-0.3 -0.4,-0.4c1.5,0 2.9,-0.3 3.9,-1.1c0.2,-0.2 0.4,-0.3 0.6,-0.5c1.1,-0.9 1.4,-1.1 2.5,-1.1c1.6,0.1 2.7,0.6 3.7,1.8c0.5,0.7 1.3,2.9 0.6,4.8c-0.4,1.1 -1.2,1.7 -2.5,2c0,0 -0.1,0 -0.1,0c0,0 0,0 0,0c-1,0.3 -2.6,0.1 -3.8,-1.1z"/>
            <path d="m54.64372,69.80174c-1.3,-1.2 -3,-1.7 -4.7,-1.5l-10.9,1.5l0,-32.6c0,-3 -2.3,-5.6 -5.2,-5.7c-3.1,-0.1 -5.7,2.4 -5.7,5.6l0,11.4c-0.7,-0.4 -1.5,-0.6 -2.4,-0.6c-2.3,0 -4.3,1.5 -5.1,3.6c-0.7,-0.4 -1.6,-0.7 -2.5,-0.7c-2.3,0 -4.3,1.6 -4.9,3.8c-0.8,-0.5 -1.7,-0.7 -2.7,-0.8l0,0c-1,0 -2,0.3 -2.9,0.8c-1.7,1.1 -2.7,2.9 -2.7,4.9l0,3.1c0,8.5 1.5,15.4 4.4,23.4l0.8,2.2c0.2,0.6 0.9,0.9 2.2,1s23.9,0 23.9,0c0.3,0 0.8,-0.1 1,-0.3l6.7,-4.5l9.2,-4.4c1.6,-0.8 2.9,-2.2 3.3,-4c0.6,-2.4 -0.2,-4.7 -1.8,-6.2zm-2.7,7.2l-9.4,4.5c-0.1,0 -0.1,0.1 -0.2,0.1l-6.4,4.3l-23.4,0c-3,-8 -4.6,-15.2 -4.6,-23.8l0,-2.8c0,-0.7 0.2,-1.3 0.6,-1.8c0.5,-0.6 1.2,-0.9 1.9,-0.9c0,0 0,0 0,0c1.4,0 2.5,1.2 2.5,2.6l0,3.4c0,0.8 0.6,1.5 1.4,1.6c0.9,0.1 1.7,-0.6 1.7,-1.6c0,0 0,-0.1 0,-0.1l0,-6.7c0,-1.3 1.1,-2.3 2.4,-2.1c1.1,0.1 1.8,1.1 1.8,2.2l0,1.7c0,0 0,0 0,0l0,3.1c0,0.9 0.7,1.6 1.5,1.6c0.8,0 1.5,-0.7 1.5,-1.6l0,-4.7l0,-2.5c0,-1.3 1,-2.5 2.2,-2.6c1.4,-0.1 2.6,1.1 2.6,2.5l0,5.1c0,0.8 0.6,1.5 1.4,1.6c0.9,0.1 1.7,-0.6 1.7,-1.6l0,-5.1l0,-16.3c0,-1.3 1,-2.5 2.2,-2.6c1.4,-0.1 2.6,1.1 2.6,2.5l0,34.6c0,1.1 0.8,1.7 1.7,1.6c3.2,-0.4 12.6,-1.7 12.6,-1.7c0.8,-0.1 1.7,0.1 2.3,0.7c0.6,0.6 1,1.4 1,2.2c0,1.1 -0.6,2.2 -1.6,2.6z"/>
          </svg>
        );
      default:
        return null;
    }
  };

  const getTitle = () => {
    switch (value) {
      case 'left':
        return 'Left Hand Only';
      case 'right':
        return 'Right Hand Only';
      case 'both':
        return 'Both Hands';
      default:
        return '';
    }
  };

  return (
    <button
      onClick={handleClick}
      title={getTitle()}
      className={`hand-toggle ${className}`}
      disabled={disabled}
    >
      {getIcon()}
      
      <style>{`
        .hand-toggle {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 3px solid white;
          background: rgba(17, 24, 39, 0.8);
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.2s ease-out;
          backdrop-filter: blur(10px);
        }

        .hand-toggle:hover {
          transform: scale(1.05);
          background: rgba(59, 130, 246, 0.3);
          border-color: #3b82f6;
        }

        .hand-toggle:active {
          transform: scale(0.95);
        }

        /* Responsive */
        @media (max-width: 768px) {
          .hand-toggle {
            width: 36px;
            height: 36px;
            border-width: 2px;
          }
        }
      `}</style>
    </button>
  );
};

export default HandToggle;
